<div id="main-container" style="margin: 0 auto;width: 100%;margin-top: 40%;display: block;text-align: center;"  class="loginas-contaiter">
    {{loginMessage}}
    <br>
    <a class="login" *ngIf="hasError" [href]="loginUrl">{{ 'Common.BackToLogin' | translate}} </a>
</div>
